import Link from 'next/link';

import { FlexibleDiv } from '@components/formStyles';
import { CampaignPromotionItemViewModel } from '@api/index';

import {
  Img,
  Title,
  Description,
  Marker,
  LogoWrapper,
  ContentWrapper,
  FlexWrapper,
  CampaignImgWrapper,
  StyledImage,
} from './styled';
const Campaign = ({
  icons,
  images,
  subText,
  name,
  url,
  onClick,
  showName = true,
}: Omit<CampaignPromotionItemViewModel, 'homePageImages'> & {
  onClick?: () => void;
  showName?: boolean;
}) => {
  return (
    <Link href={url} onClick={() => onClick?.()} prefetch={false}>
      <CampaignImgWrapper>
        <StyledImage
          priority={true}
          key={images[0]?.url}
          src={images[0]?.url ?? '/static/images/setur-static.jpg'}
          alt={name}
          width={500}
          height={400}
        />
        <ContentWrapper>
          {icons.length ? (
            <FlexibleDiv bottom={27} left={26}>
              <LogoWrapper>
                <Img
                  height={88}
                  width={73}
                  src={icons[0]?.url || '/static/images/setur-static.jpg'}
                  alt={icons[0]?.alt || 'Setur Görseli Hazırlanmakta'}
                />
              </LogoWrapper>
            </FlexibleDiv>
          ) : null}
          {showName ? (
            name || subText ? (
              <FlexWrapper>
                <FlexibleDiv right={20} top={6}>
                  <Marker />
                </FlexibleDiv>
                <div>
                  {name ? <Title>{name}</Title> : null}
                  {subText ? <Description>{subText}</Description> : null}
                </div>
              </FlexWrapper>
            ) : null
          ) : null}
        </ContentWrapper>
      </CampaignImgWrapper>
    </Link>
  );
};

export default Campaign;
